import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Sidebar = ({ accounts, activeId, onSelectAccount }) => {
  return (
    <div className="w-20 md:w-64 bg-gray-950 border-r border-gray-800 h-full flex flex-col pt-4 pb-4 shrink-0 transition-all duration-300">
      <div className="px-4 mb-6 flex items-center justify-center md:justify-start space-x-3">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center shadow-lg shadow-blue-900/20 overflow-hidden shrink-0">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/88577bf33df42fc0146f97d319dec09e53e853cea0703950ad5359a5e5d96838b999b0f46937cf1ca2813cf9b0cbaa03/images/aW1hZ2UvcG5n/2310aeb4984f4005e562c0177ff4d546.png" 
            alt="MAX Logo" 
            className="w-full h-full object-cover"
          />
        </div>
        <span className="text-white font-bold text-xl hidden md:block tracking-tight">MAX Multi</span>
      </div>

      <div className="flex-1 overflow-y-auto px-2 md:px-3 space-y-2 no-scrollbar">
        {accounts.map((account) => {
          const isActive = account.id === activeId;
          return (
            <button
              key={account.id}
              onClick={() => onSelectAccount(account.id)}
              className={`w-full relative flex items-center space-x-3 p-3 rounded-xl transition-all duration-200 group
                ${isActive 
                  ? 'bg-blue-600/10 border border-blue-500/30 text-white' 
                  : 'hover:bg-gray-900 border border-transparent text-gray-400 hover:text-gray-200'
                }
              `}
            >
              {isActive && (
                <motion.div 
                  layoutId="active-indicator"
                  className="absolute left-0 top-2 bottom-2 w-1 bg-blue-500 rounded-r-full"
                />
              )}
              
              <div className="relative flex-shrink-0">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold
                  ${isActive ? 'bg-blue-600 text-white' : 'bg-gray-800 text-gray-300 group-hover:bg-gray-700'}
                `}>
                  {account.name.charAt(0)}
                </div>
                {account.unread > 0 && (
                  <div className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full min-w-[18px] text-center border border-gray-950 shadow-sm">
                    {account.unread > 99 ? '99+' : account.unread}
                  </div>
                )}
              </div>

              <div className="hidden md:flex flex-col items-start overflow-hidden">
                <span className="font-medium truncate w-full text-left">{account.name}</span>
                <span className="text-xs text-gray-500 truncate w-full text-left">{account.email}</span>
              </div>
            </button>
          );
        })}
      </div>

      <div className="px-2 md:px-3 pt-4 border-t border-gray-800 mt-auto">
        <button className="w-full flex items-center justify-center md:justify-start space-x-3 p-3 rounded-xl text-gray-400 hover:text-white hover:bg-gray-900 transition-colors border border-dashed border-gray-700 hover:border-gray-500">
          <SafeIcon icon="FiPlus" className="text-lg" />
          <span className="hidden md:block font-medium">Add Account</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;